<template>
<div  v-if="lobby">
    <div class="lobby" :class="{ 'active_room' : lobby._id === currentRoom._id }">
        <RoomView :room="lobby"/>
    </div>
    <div class="brkrooms-toolbar">
        <SidePaneSearch @keyword-changed="handleSearch"/>
        <AddRoom v-if="controls['CREATE_BREAKOUTS']" @new-room-added="scrollRoomsToEnd"/>
    </div>
    <el-menu id="rooms-container" class="breakout-rooms">
        <template v-for="breakOutRoom in sortRooms(filterRooms(rooms, searchKeyword, this.$store.state.user.controls['SEE_PARTICIPANTS_NAMES']))">
            <template v-if="breakOutRoom.isVisible">
                <el-menu-item v-if="breakOutRoom.parent" :class="{ 'active_room' : breakOutRoom._id === currentRoom._id }" :key="breakOutRoom._id" :index="breakOutRoom._id">
                    <room-view :room="breakOutRoom" shadow="hover"></room-view>
                </el-menu-item>
            </template>
        </template>
    </el-menu>
</div>
</template>

<script>
import axios from '../../client';
import RoomView from "./Room";
import {
    mapState,
    mapGetters
} from 'vuex'
import SidePaneSearch from './SidePaneSearch'
import AddRoom from './AddRoom'

export default {
    name: "Rooms",
    components: {
        RoomView,
        SidePaneSearch,
        AddRoom
    },
    data(){
        return{
            searchKeyword: ''
        }
    },
    created: async function () {
        await axios.get('/api/rooms?parent=' + this.mainRoom._id).then((response) => {
            let rooms = [].concat(this.mainRoom, response.data)
            this.$store.commit('rooms/setRooms', rooms);
        });
    },
    methods: {
        handleSearch(keyword){
            this.searchKeyword = keyword
        },
        scrollRoomsToEnd(){
            const container = this.$el.querySelector("#rooms-container");
            container.scrollTop = container.scrollHeight;
            this.animateRoom(container.lastChild)
        },
        animateRoom(roomElement){
            roomElement && roomElement.classList.add('animate')
        }
    },
    computed: {
        ...mapState({
            mainRoom: state => state.rooms.mainRoom,
            isBreakoutRoomsHidden: state => state.rooms.isBreakoutRoomsHidden,
            rooms: state => state.rooms.rooms,
            currentRoom: state => state.rooms.currentRoom,
            controls: state => state.user.controls,
        }),
        ...mapGetters('rooms', {
            sortRooms: 'sortRooms',
            filterRooms: 'filterRooms',
        }),
        lobby: function(){
            return this.rooms.find(room => !room.parent)
        }
    }
}
</script>

<style scoped>
.breakout-rooms {
    overflow-y: auto;
    flex: 1;
    scroll-behavior: smooth;
}
.breakout-rooms::-webkit-scrollbar{
    display: block !important;
    background: transparent;
    width: 6px;
}

.breakout-rooms::-webkit-scrollbar-thumb {
    background: #5E5E7A;
    border-radius: 10px;
    width: 6px;
}

.el-menu {
    background-color: unset !important;
    border-right: none;
    width: 100%;
    background-color: #121214;
}

.el-menu-item, .lobby {
    text-align: left;
    margin-bottom: 4px;
    padding: 5px 2px !important;
    background-color: white;
    color: #E7E6FA;
    width: calc(100% - 8px);
    height: 94px;
    background: #292933;
    border: 2px solid #292933;
    line-height: unset !important;
    transition: all ease-in 0.2s;
}

.el-menu-item{
    width: calc(100% - 24px);
    padding: 5px 3px;
    margin: 10px;
    box-sizing: border-box;
    border-radius: 8px;
}

.el-menu-item:hover,
.lobby:hover {
    background: #3D3D4D;
}


::-webkit-scrollbar {
    width: 8px !important;
}

::-webkit-scrollbar{
    width: 8px !important;
    height: 6px;
}

::-webkit-scrollbar-thumb {
    width: 8px !important;
}

.lobby.active_room, .el-menu-item.active_room{
    width: calc(100% - 24px);
    box-shadow: 0px 0px 10px 2px #50C6DF;
    margin: 10px !important;
    box-sizing: border-box;
    border-radius: 8px;
    height: 94px !important;
}

div.lobby {
    height: 94px !important; /* exclude padding */
    cursor: pointer;
    background-color: #33333D;
    margin: 10px;
    width: calc(100% - 24px);
    border-radius: 8px;
}

.el-aside {
    max-height: 85vh;
    width: auto !important;
    display: flex;
    flex-direction: column;
}

.brkrooms-toolbar {
    padding: 8px;
    background-color: #1E1E29;
    margin: 0px 8px 5px 0px;
}

.animate {
    animation-name: blink;
    animation-duration: 0.9s;
    animation-iteration-count: 1;
}

@keyframes blink {
  from {
    background-color: #292933;
    border: 2px solid #292933;
  }
  to {
    background-color: #5D5D7A;
    border: 2px solid #5D5D7A;
  }
}
</style>
